/**
 * Показ телефона на экране.
 *
 * Обёртка над @cc/shared: правило нормализации и формат номера — общие для сервера
 * и браузера, второго варианта в UI быть не должно, иначе в карточке и в отчёте
 * один номер будет выглядеть по-разному.
 */

import { formatPhone as formatPhoneShared, maskPhoneDisplay } from '@cc/shared';

/** +7 (999) 123-45-67 — основной вид в карточке контакта */
export function formatPhone(phone: string): string {
  return formatPhoneShared(phone);
}

/** +7 (999) ***-**-67 — списки и экспорт, где полный номер не нужен */
export function maskPhone(phone: string): string {
  return maskPhoneDisplay(phone);
}

/** Номер для набора: цифры без разделителей */
export function toDialString(phone: string): string {
  return phone.replace(/\D/g, '');
}
